module.exports = __webpack_public_path__ + "static/media/answer4.ab7c2c5d.png";